import AuthHelper from "@/services/AuthHelper";
import { authStore } from "@/store/typed";
import { AUTHORIZER_URL } from "@/utils/Constants";
import { Component, Vue } from "vue-property-decorator";
import { User } from "../../models";
import { camelToUnderscore } from "../../utils/Typography";

@Component
export default class OauthMixin extends Vue {
  readonly path = camelToUnderscore(User.type);
  readonly routes = this.$getModelRoutes(this.path);
  readonly authHelper = new AuthHelper();

  async startOauth() {
    const codeVerifier = await authStore.generateCodeVerifier();

    const uri = this.authHelper.generateAuthorizeUri(codeVerifier);

    window.location.href = uri;
  }

  startRegistration() {
    window.location.href = this.authHelper.getRegistrationUri();
  }

  async logout() {
    try {
      await authStore.invalidateToken();
    } finally {
      window.location.href = AUTHORIZER_URL + '/logout?redirect_uri=' + encodeURIComponent(window.location.href);
    }
  }
}
